/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const RelaxedWave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Relaxed wave"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#8E00E5"
        d="M4.5 2.833c0-.46.373-.833.833-.833.87 0 1.703.403 2.309 1.135.314.38.689.532 1.025.532s.71-.152 1.025-.532C10.298 2.403 11.13 2 12 2s1.703.403 2.309 1.135c.314.38.689.532 1.025.532s.71-.152 1.025-.532C16.965 2.404 17.796 2 18.666 2a.833.833 0 1 1 0 1.667c-.335 0-.71.152-1.024.531-.606.732-1.438 1.135-2.308 1.135s-1.703-.403-2.309-1.135c-.314-.38-.689-.531-1.025-.531s-.71.152-1.025.531c-.606.732-1.438 1.135-2.308 1.135S6.964 4.93 6.358 4.198c-.314-.38-.689-.531-1.025-.531a.833.833 0 0 1-.833-.834M12 7C6.477 7 2 11.477 2 17v5h20v-5c0-5.523-4.477-10-10-10"
      />
      <path
        fill="#0E0E0E"
        d="M6.468 12.192a.833.833 0 0 1 1.174.11c.314.38.689.531 1.025.531s.71-.152 1.025-.531a.833.833 0 0 1 1.283 1.063c-.606.732-1.438 1.135-2.308 1.135s-1.703-.403-2.309-1.135a.833.833 0 0 1 .11-1.173m1.485 5.211a.833.833 0 0 1 1.144-.283c.762.46 1.81.713 2.903.713s2.142-.254 2.903-.713a.833.833 0 0 1 .861 1.427c-1.08.651-2.444.953-3.764.953s-2.684-.302-3.764-.953a.833.833 0 0 1-.283-1.144m6.355-5.101a.833.833 0 1 0-1.283 1.063c.606.732 1.438 1.135 2.308 1.135s1.703-.403 2.309-1.135a.833.833 0 0 0-1.284-1.063c-.314.38-.689.531-1.025.531s-.71-.152-1.025-.531"
      />
    </g>
  </svg>
);

export const RelaxedWaveIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'relaxed-wave-icon'}
      icon={RelaxedWave}
      {...props}
      size={size}
    />
  );
};
